<template>
  <div class="container" v-if="member">

    <m-row class="mt-4">

      <m-col lg="12" >
        <memlist-text-input
          :disabled="true"
          size="sm"
          v-model="member.member_id"
          :title="$t('MEMBER.MEMBER_ID')"
          layout="vertical"
        />
      </m-col>

    </m-row>

    <m-row class="mt-4">

      <m-col lg="12" >
        <memlist-text-input
          :disabled="true"
          size="sm"
          v-model="member.email"
          :title="$t('MEMBER.EMAIL')"
          layout="vertical"
        />
      </m-col>

    </m-row>

    <m-row class="mt-4">

      <m-col lg="12" >
        <memlist-text-input
          :disabled="true"
          size="sm"
          v-model="member.firstname"
          :title="$t('MEMBER.FIRSTNAME')"
          layout="vertical"
        />
      </m-col>

    </m-row>

    <m-row class="mt-4">

    <m-col lg="12" >
      <memlist-text-input
        :disabled="true"
        size="sm"
        v-model="member.lastname"
        :title="$t('MEMBER.LASTNAME')"
        layout="vertical"
      />
    </m-col>

  </m-row>

  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {

  name: 'MemberDetails',

  props: ['member_id'],

  mixins: [ toasts ],

  components: {

  },

  watch: {
    member_id() {
      if (!this.member_id) {
        this.member = null;
        return;
      }

      this.get_member();
    }
  },

  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'currentMemberId', 'companies', 'periods', 'profile', 'settings','isTHS']),
  },

  methods: {

    async get_member() {
      try {
        const response = await axios.get(`/member/${this.member_id}`);
        this.member = response.data.member;
      } catch (error) {
        console.error(error);
      }
    }

  },

  mounted() {
    if (!this.member_id) {
      this.member = null;
      return;
    }
    
    this.get_member();
  },

  data() {
    return {
      member: {}
    };
  }
};

</script>
